import http from '@/utils/http'
import { stringify } from 'qs'

// 字典非子父级方法
export function getCodes (data) {
  return http.post('/system/cache/getCode',stringify(data))
}
// 字典子父级方法
export function getTreeCodes (data) {
  return http.post('/system/cache/getCategoryCodeTree',stringify(data))
}
